<div class="main-wrapper" [ngStyle]="{'background-attachment': section?.background_attachment,'background-color': section?.background_color}" [attr.data-bg]="section?.bg_image">
  <div class="container">
    <div class="row">
      <div class="section_1_headerArea col-lg-6 col-md-6 col-12 col-sm-6" [ngClass]="{'memorial-height': page === 'memorial-fundraising' }">
        <h1 class="heading">{{section.header}}</h1>
        <div class="sub-heading">
          Now with <span>0<b>%</b></span> platform fees*
        </div>
        <div class="hr"></div>
        <div class="glider-wrapper" [ngClass]="{'memorial': page === 'memorial-fundraising'}" *ngIf="page !== 'cancer-crowdfunding'">
          <ngx-glide [showArrows]="false" [showBullets]="true" [perView]="1" [bound]="true" [dragThreshold]="false" [breakpoints]="breakpoints">
            <div class="widget-new" *ngFor="let item of section?.data_images">
              <img class="slider-img d-lg-block d-md-none d-sm-none d-none" [attr.data-src]="item?.url"/>
              <div class="txt"> {{item?.text}} </div>
            </div>
          </ngx-glide>
        </div>

        <div class="youtube-wrap" *ngIf="page === 'cancer-crowdfunding'">
          <p>Watch how Karan crowdfunded and helped his friend pay his bills.</p>
          <iframe height="230" src="https://www.youtube.com/embed/9HlIZAlaGpg" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 col-sm-6 flex-align-center">
        <div class="lead-form">
          <div class="header text-center">
            <img loading="lazy" data-src="/assets/images/how-it-works/ketto-logo.svg" alt="" class="ketto-bird"/>
            <div class="main-title">
              Need Money Urgently?
              <div inViewport (inViewportAction)="whatsappToggle($event)" class="sac-wrapper" *ngIf="showWhatsAppChatPageList.includes(page)">
                <a type="submit" (click)="systemEvent($event)" mat-button class="chat-on-whatsapp" target="_blank" [href]="'https://api.whatsapp.com/send?phone=91' + vars.contactUsMobNumber">
                  <mat-icon class="icon-whatsapp icon-btn"></mat-icon>
                  Chat with us on whatsapp
                </a>
              </div>
            </div>
          </div>
          <div *ngIf="showRaisedOnPageList.includes(page)">
            <ng-container *ngTemplateOutlet="raised"></ng-container>
          </div>

          <app-common-talktous-modal class="action-btns" [header]="false" label="Get a call" [closebtn]="false"
                                    [showSacBtn]="true" [campaignCount]="vars.campaignCount"
                                    leadQueryType="want_to_raise_funds" frCause="medical" [askQuery]="false"
                                    [hideFields]="{typeOfQuery: true, cause: true}" [successPopup]="true"
                                    [hideConnectBtn]="true"
                                    *ngIf="showTalkToUsPageList.includes(page)">
          </app-common-talktous-modal>
        </div>
      </div>
    </div>
  </div>
</div>

<div #whatsAppSticky class="d-lg-none d-md-none" (click)="pushWhatsappEvent($event)">
  <a href="javascript:void(0)" class="whatsapp-share-unstick" mat-raised-button>
    <i class="icon-whatsapp"></i>
    Chat with us on Whatsapp</a>
</div>


<ng-template #raised>
  <div class="raised-wrapper">
    <!-- <div class="inline-div">
      <h3>₹{{ vars?.RAISED }}</h3>
      <span>Raised</span>
    </div> -->
    <div class="inline-div">
      <h3>{{ vars?.DONORS }}</h3>
      <span>Contributors</span>
    </div>
    <div class="inline-div">
      <h3>{{ vars?.FUNDRAISERS }}</h3>
      <span>Fundraisers</span>
    </div>
  </div>
  <div class="started-fundraiser">
    212 people started a fundraiser in last 2 days
  </div>
  <div class="start-fundraiser">
    <app-startfundraiser-button info2="" [pageName]="vars.pageName" [label]="label" [width]="width" height="51px"></app-startfundraiser-button>
  </div>
</ng-template>
